import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import "./components"
import "@/plugins/mixins";
import VueGates from 'vue-gates';
import VCalendar from 'v-calendar';

Vue.config.productionTip = false;



Vue.use(VueGates);
Vue.use(VCalendar, {componentPrefix: 'vc'})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
